import {
  INQUIRY_FF_ENABLE_LOADING,
  INQUIRY_FF_DISABLE_LOADING,
  INQUIRY_FF_PAGINATION,
  INQUIRY_FF_RESET_FILTER,
  INQUIRY_FF_SET_FILTER,
  INQUIRY_FF_APPLY_FILTER,
  INQUIRY_FF_UPDATE_DATA,
  INQUIRY_FF_GET_STATUS_WISE_COUNT,
  INQUIRY_FF_RESET_PAGINATION,
  INQUIRY_FF_SET_PREV_PAGINATION,
  INQUIRY_FF_FETCH_ERROR,
  INQUIRY_FF_APPLY_SORT,
  INQUIRY_FF_DETAILS,
  INQUIRY_FF_BIDS_RANKING_DATA,
  INQUIRY_FF_BIDS_RANKING_DATA_IS_LOADING,
  INQUIRY_FF_BOOKING_STAT_COUNTS_DATA,
  INQUIRY_FF_BOOKING_STAT_COUNTS_DATA_IS_LOADING,
} from './constants';
import { getLastSortedColumnValue } from '../utils/pagination';
import {
  fetchAllInquriesForFF,
  fetchInquiryDetailsForShipper,
  fetchInquiryStatusWiseCountForFF,
  getBidRanksFFInquiry,
} from 'src/api/inquiry';
import { getBookingStat } from 'src/api/booking';
import { message } from 'antd';

export const fetchFF = () => async (dispatch, getState) => {
  dispatch({
    type: INQUIRY_FF_ENABLE_LOADING,
  });

  dispatch({
    type: INQUIRY_FF_BIDS_RANKING_DATA_IS_LOADING,
    data: true
  });
  
  dispatch({
    type: INQUIRY_FF_BOOKING_STAT_COUNTS_DATA_IS_LOADING,
    data: true
  });

  const appliedFilters = getState().inquiryFFReducer.appliedFilters;
  const pagination = getState().inquiryFFReducer.pagination;
  const polList = appliedFilters.polList?.length ? appliedFilters.polList.map(filter => filter.key) : [];
  const podList = appliedFilters.podList?.length ? appliedFilters.podList.map(filter => filter.key) : [];
  const originCountryList = appliedFilters.originCountryList?.length ?
    appliedFilters.originCountryList.map(filter => filter.key) : [];
  const destinationCountryList = appliedFilters.destinationCountryList?.length ?
    appliedFilters.destinationCountryList.map(filter => filter.key) : [];
  const internalReferenceNumberList = appliedFilters.internalReferenceNumberList ?
    appliedFilters.internalReferenceNumberList.map(filter => filter.label) : [];
  const typeList = appliedFilters.typeList ? appliedFilters.typeList : [];
  const status = appliedFilters.status ? appliedFilters.status : 'ALL';
  const sortBy = appliedFilters.sortBy ? appliedFilters.sortBy : 'received_date';
  const modeList = appliedFilters.modeList ? appliedFilters.modeList : [];
  const shipperList = appliedFilters.shipperList
    ? appliedFilters.shipperList.map(item => item.key)
    : [];
    const originCityList = appliedFilters?.originCityList?.length ? appliedFilters.originCityList.map(filter => filter.key) : [];
    const destinationCityList = appliedFilters?.destinationCityList?.length ? appliedFilters.destinationCityList.map(filter => filter.key) : [];
  const body = {
    ...appliedFilters,
    polList,
    internalReferenceNumberList,
    originCountryList,
    destinationCountryList,
    podList,
    typeList,
    status,
    sortBy,
    modeList,
    polSearch: undefined,
    podSearch: undefined,
    shipperIdList: shipperList,
    lastInquiryId: getLastColumnId(pagination),
    lastSortedColumnValue: getLastSortedColumnValue(pagination),
    currentPageNumber: pagination.currentPageNumber,
    resultPerPage: Number(pagination.resultPerPage),
    nextOrPrev: pagination.nextOrPrev,
    originCityList,
    destinationCityList
  };

  const startGetBidRanksFFInquiry = async (response) => {
    const allInquiryIds = response?.response?.data?.map(singleInquiryData => singleInquiryData.id);

    const responseBids = await getBidRanksFFInquiry({
      inquiryIdList: allInquiryIds,
    });
    if (responseBids.isSuccess){
      const inquiryIdvsBidDataRankingMap = responseBids?.data?.reduce((acc, curr) => {
        if (curr?.id){
          acc[curr.id] = [curr];
        }
        return acc;
      }, {});
      
      dispatch({
        type: INQUIRY_FF_BIDS_RANKING_DATA,
        data: inquiryIdvsBidDataRankingMap
      });
      
      dispatch({
        type: INQUIRY_FF_BIDS_RANKING_DATA_IS_LOADING,
        data: false
      });
      
      const startfetchBookingStatsForInquiry = async () => {
        const allConfirmedInquiryIds = allInquiryIds.reduce((acc, inquiryId) => {
          if (inquiryIdvsBidDataRankingMap?.[inquiryId]?.[0]?.bidDetails?.isConfirmed){
            acc.push(inquiryId);
          }
          return acc;
        }, []);

        if (allConfirmedInquiryIds.length > 0){
          const statCounts = await getBookingStat({
            inquiryIdList: allConfirmedInquiryIds,
          });
          
          if (statCounts.isSuccess){
            const inquiryIdvsBookingStatCountsMap = statCounts.data;
      
            dispatch({
              type: INQUIRY_FF_BOOKING_STAT_COUNTS_DATA,
              data: inquiryIdvsBookingStatCountsMap
            })
            
          } else {
            message.error(response.errorMessage);
          }
        }
        
        dispatch({
          type: INQUIRY_FF_BOOKING_STAT_COUNTS_DATA_IS_LOADING,
          data: false
        });
      }; 

      await startfetchBookingStatsForInquiry();

    } else {
      message.error(response.errorMessage);
      dispatch({
        type: INQUIRY_FF_BIDS_RANKING_DATA_IS_LOADING,
        data: false
      });
    }
  };

  const startFetchAllInquriesForFF = async () => {
    const response = await fetchAllInquriesForFF(body);
    if (response.isSuccess) {
      dispatch({
        type: INQUIRY_FF_UPDATE_DATA,
        data: response.response,
      });

      startGetBidRanksFFInquiry(response);

    } else {
      dispatch({
        type: INQUIRY_FF_FETCH_ERROR,
        data: response.errorMessage,
      });
    }
    dispatch({
      type: INQUIRY_FF_DISABLE_LOADING,
    });
  };

  const startFetchInquiryStatusWiseCountForFF = async () => {
    const responseIC: any = await fetchInquiryStatusWiseCountForFF({
      polList,
      modeList,
      internalReferenceNumberList,
      originCountryList,
      destinationCountryList,
      podList,
      shipperIdList: body.shipperIdList,
      originCityList,
      destinationCityList
    });
    if (responseIC.isSuccess) {
      dispatch({
        type: INQUIRY_FF_GET_STATUS_WISE_COUNT,
        data: responseIC.response,
      });
    }
  }


  startFetchAllInquriesForFF();
  startFetchInquiryStatusWiseCountForFF();

};
const getLastColumnId = (pagination) => {
  switch (pagination.nextOrPrev) {
    case 'prev':
      return pagination.lastItemIdPrev;
    case 'next':
      return pagination.lastItemIdNext;
    default:
      return null;
  }
};

export const applyFilters = () => async (dispatch, getState) => {
  dispatch({
    type: INQUIRY_FF_APPLY_FILTER,
  });
  dispatch({
    type: INQUIRY_FF_RESET_PAGINATION,
  });
  dispatch(fetchFF());
};

export const applySortBy = sort => async (dispatch, getState) => {
  dispatch({
    type: INQUIRY_FF_APPLY_SORT,
    data: sort,
  });
};

export const setFilters = (filters, applyFilter = false) => (dispatch) => {
  dispatch({
    data: filters,
    type: INQUIRY_FF_SET_FILTER,
  });
  if (applyFilter) {
    dispatch(applyFilters());
  }
};

export const setPagination = pageData => async (dispatch, getState) => {
  dispatch({
    type: INQUIRY_FF_PAGINATION,
    data: pageData,
  });
  dispatch(fetchFF());

};

export const setPrevPagination = () => (dispatch) => {
  dispatch({
    type: INQUIRY_FF_SET_PREV_PAGINATION,
  });
  dispatch(fetchFF());
};

export const resetFilters = (apiCall = true) => (dispatch, getState) => {
  dispatch({
    type: INQUIRY_FF_RESET_FILTER,
  });
  if (apiCall) dispatch(fetchFF());
};

export const resetPagination = () => async (dispatch) => {
  dispatch({
    type: INQUIRY_FF_RESET_PAGINATION,
  });
  dispatch(fetchFF());
};

export const inquiryDetailsFF = body => async (dispatch) => {
  dispatch(fetchInquiryDetailsFF(body));
};

export const fetchInquiryDetailsFF = body => async (dispatch) => {
  const response = await fetchInquiryDetailsForShipper(body);
  dispatch({
    type: INQUIRY_FF_DETAILS,
    data: response.data,
  });
};
